import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AccountSidebar } from "@/components/shell/account-sidebar";
import { SkipLink } from "@/components/shell/skip-link";
import { AppMain } from "@/components/shell/app-main";
import { Topbar } from "@/components/shell/topbar";
import { CommandPalette } from "@/components/shell/command-palette";

export default function AccountLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider style={{ "--sidebar-width": "236px", "--sidebar-width-icon": "56px" } as React.CSSProperties}>
      <SkipLink />
      <AccountSidebar />
      <SidebarInset className="min-w-0 bg-canvas">
        <Topbar />
        <AppMain>
          <div className="mx-auto w-full max-w-[1360px] p-4 lg:p-6">{children}</div>
        </AppMain>
      </SidebarInset>
      <CommandPalette />
    </SidebarProvider>
  );
}
